// Arriving from the digest email (?from=digest) logs digest_opened once, then drops the parameter.
import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { track } from '../lib/track';

export function DigestOpen() {
  const { search, pathname } = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    const p = new URLSearchParams(search);
    if (p.get('from') !== 'digest' || done.current) return;
    done.current = true;
    track('digest_opened', { cadence: 'weekly' });
    p.delete('from');
    navigate({ pathname, search: p.toString() ? `?${p}` : '' }, { replace: true });
  }, [search, pathname, navigate]);
  return null;
}
